import { AgResourceLanguage } from '../types';
import { banners as EnUsBanner } from '../en-us/banners';

export const banners: AgResourceLanguage['banners'] = {
  ...EnUsBanner,
  gift: {
    title: 'Envía un regalo a amigos y familiares',
    description:
      'Ahora tus seres queridos pueden probar AG1 con el regalo de Nutrición Fundamental diaria.',
    iconAccessibleName: 'Regalo',
    imageAccessibleName: 'Regalo',
    buttonCloseLabel: 'Cerrar',
    buttonShopLabel: 'Comprar regalos'
  },
  paymentMethod: {
    title: 'Método de pago faltante',
    description:
      'Añade un método de pago a tu suscripción para seguir recibiendo pedidos de suscripción.',
    addCtaBtnLabel: 'Añadir Ahora',
    updateCtaBtnLabel: 'Actualizar Ahora'
  },
  stockBanner:
    'Los productos en tu próximo envío están actualmente fuera de stock y no serán enviados. Los artículos fuera de stock están excluidos del total de tu pedido.',
  upcomingOrderBanner: {
    preparing: 'Preparando',
    shipped: 'Enviado',
    delivered: 'Entregado',
    preparingDescription: 'Estamos preparando tu pedido.',
    shippedDescription: 'Tu pedido actual está en camino.',
    deliveredDescription: '¡Hurra! Has recibido AG1.',
    orderDetailsLink: 'Ver detalles del pedido',
    trackingLink: 'Ver estado del envío'
  },
  cookies: {
    text: 'Utilizamos cookies de terceros y tecnologías de seguimiento que recopilan información sobre tu uso del sitio. Estos terceros pueden utilizar tu información para sus propios fines, como se describe en nuestra ',
    link: 'Política de privacidad.'
  },
  promotionalBanner: {
    promotionMessage: 'Gran valor',
    title: 'Más de lo bueno',
    descriptionPart1: 'Cambia tu suscripción a 2 bolsas y obtén cada una por €74,50 ',
    descriptionPart2:
      ' — perfecto para parejas, familias y miembros muy activos que desean una segunda porción diaria de AG1.',
    disclaimerFull:
      'Siempre es mejor consultar a tu proveedor de salud para determinar qué mezcla nutricional es la mejor para ti.',
    disclaimerShort:
      'Consulta a tu proveedor de salud para determinar el mejor nivel nutricional para ti.',
    buttonText: 'Añadir una bolsa'
  },
  offerSoldOut: 'Esta oferta está agotada',
  offerVariantsSoldOut: {
    soldOut_one: '{{soldOutProducts}} está agotado',
    soldOut_other: '{{soldOutProducts}} están agotados'
  }
};
